import { z } from "zod";

export const certificateTypeSchema = z.object({
  name: z
    .string({
      required_error: "El nombre del tipo de certificado es obligatorio",
      invalid_type_error: "El nombre debe ser un texto",
    })
    .trim()
    .min(1, "El nombre del tipo de certificado es obligatorio")
    .max(255, "El nombre no puede exceder 255 caracteres"),
  description: z
    .string()
    .trim()
    .max(500, "La descripción no puede exceder 500 caracteres")
    .optional()
    .or(z.literal("")),
  active: z.boolean({
    required_error: "El estatus es obligatorio",
    invalid_type_error: "El estatus debe ser verdadero o falso",
  }).default(true),
  xsd:z.boolean(),
  indefiniteValidity:z.boolean().default(true),//para vigencia
  years:z.number().optional(),
  months:z.number().optional(),
  days:z.number().optional()
  
});
